import script from "./login-google.vue?vue&type=script&setup=true&lang=js"
export * from "./login-google.vue?vue&type=script&setup=true&lang=js"

import "./login-google.vue?vue&type=style&index=0&id=453b41cd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-453b41cd"]])

export default __exports__